import { secureGet, securePost, securePut } from '../../Config/ApiConfig';

export const getTransactions = async ({ page, size, sort_by, sort_direction, filters, search_string }, is_admin) => {
    try {
        let url = `/transactions${!is_admin ? '/me' : ''}?page=${page}&per_page=${size}`;
        if (search_string) {
            url += `&search_string=${search_string}`;
        }
        if (sort_by) {
            url += `&sort_by=${sort_by}`;
        }
        if (sort_direction) {
            url += `&sort_direction=${sort_direction}`;
        }
        if (filters) {
            url += `&filters=${JSON.stringify(filters)}`;
        }
        const response = await secureGet(url);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const updateTransaction = async (id, body) => {
    const { data } = await securePut(`/transactions/${id}`, body);
    return data;
};

export const reconcileTransaction = async (id) => {
    const { data } = await securePost('/transactions/' + id + '/reconcile');
    return data;
};

export const createTransaction = async (body) => {
    try {
        const response = await securePost('/transactions', body);
        return response.data;
    } catch (error) {
        throw error;
    }
};
